import React from 'react';
import Text from './Text/Text';
import NumberDisplayV2 from './Utils/NumberDisplayV2';
import MarketIcon from './Utils/MarketIcon';
import { UserBalanceInfo } from './UserBalancesPortfolioTable/UserBalancesPortfolioTable';

interface AssetBalanceCardProps {
	userBalanceInfo: UserBalanceInfo;
}

const AssetBalanceCard = ({ userBalanceInfo }: AssetBalanceCardProps) => {
	return (
		<div
			className={`w-full bg-container-bg border-container-border rounded border overflow-hidden mb-4 last:mb-0 ${
				userBalanceInfo.netBase.eqZero() ? 'opacity-50' : ''
			}`}
		>
			<div className="p-2">
				<div className="flex flex-row items-center justify-between px-1 py-2 border-b border-container-border">
					<div className="flex flex-row items-center text-text-emphasis">
						<div className="relative bottom-0.5">
							<MarketIcon
								marketSymbol={userBalanceInfo.symbol}
								className="mr-3"
								sizeClass="w-5 h-5"
							/>
						</div>
						<Text.BODY1>{userBalanceInfo.symbol}</Text.BODY1>
					</div>
					<div></div>
				</div>
				<div className="flex flex-col justify-between pt-2">
					<div className="p-2">
						<div className="flex flex-row justify-between space-x-2">
							<div>
								<Text.BODY1 className="block mb-0.5 text-text-label">
									Balance
								</Text.BODY1>
								<Text.BODY1 className="block mb-0.5 text-text-emphasis">
									<NumberDisplayV2
										value={userBalanceInfo.netBase}
										displayType="asset"
										assetSymbol={userBalanceInfo.symbol}
										toTradePrecision
										isHiddenAccountValue
									/>
									<NumberDisplayV2
										value={userBalanceInfo.netQuote}
										className="text-text-label"
										displayType="notional"
										isHiddenAccountValue
									/>
								</Text.BODY1>
							</div>
							<div className="text-right">
								<Text.BODY1 className="block mb-0.5 text-text-label">
									Asset / Liability Weight
								</Text.BODY1>
								<Text.BODY1 className="block mb-0.5 text-text-emphasis">
									{`${userBalanceInfo.assetWeight}% / ${userBalanceInfo.liabilityWeight}%`}
								</Text.BODY1>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default React.memo(AssetBalanceCard);
